<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import {
  GetApiActionWithAuthorization,
  PostApiWithAuthorizationAction,
} from "../../../helpers/apiActions";
import moment from "moment-timezone";
import momentBusiness from "moment-business-days";
import { common } from "@/mixins/common";
import ViewOrderItemList from "@/components/drawers/order/viewItemList";
import CompleteOrderDialog from "../../../components/dialogs/order/CompleteOrderDialog";
import ReturnOrderItemDialog from "../../../components/dialogs/order/ReturnOrderItemDialog";
import DisplayLabelPreviewDialog from "../../../components/dialogs/order/DisplayLabelPreviewDialog";
import InvoicePreviewDialog from "../../../components/dialogs/order/InvoicePreviewDialog";
import PurchaseLabelDialog from "../../../components/dialogs/order/PurchaseLabelDialog";
import ScanFormDialog from "../../../components/dialogs/order/ScanFormDialog";

// import { isMobile, isTablet } from 'mobile-device-detect';
/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Orders",
  },
  components: {
    Layout,
    PageHeader,
    ViewOrderItemList,
    CompleteOrderDialog,
    ReturnOrderItemDialog,
    DisplayLabelPreviewDialog,
    InvoicePreviewDialog,
    PurchaseLabelDialog,
    ScanFormDialog
  },
  data() {
    return {
      title: "Orders",
      allOrdersChecked: true,
      isallOrdersIndeterminate: true,
      displayCompleteOrderDialog: false,
      displayPurchaseLabelDialog: false,
      items: [],
      selectedOrders: [],
      shippingServices: [],
      shippingOptions: [],
      selectedOrder: {},
      selectedOrderShipmentData: [],
      displayLabelPreviewDialog: false,
      displayInvoicePreviewDialog: false,
      loadingNewOrder: false,
      stores: [],
      purchaseLabelData: {},
      pageViewType: "Live Show Orders",
      tabs: [
        {
          value: "Ready To Ship",
          link: "ready_to_ship",
          icon: "fas fa-cart-plus",
          active: false,
        },
        {
          value: "Completed",
          link: "completed",
          icon: "fas fa-dolly",
          active: false,
        },
        /*{
          value: "Flagged",
          icon: "fas fa-flag",
          link: "flagged",
          active: false,
        },*/
        {
          value: "Unpaid",
          icon: "fas fa-money-check",
          link: "unpaid",
          active: false,
        },
        {
          value: "Cancelled",
          icon: "fas fa-ban",
          link: "cancelled",
          active: false,
        },
      ],
      columns: [
        {
          key: "id",
          value: "Order #",
          sortable: false,
        },
        {
          key: "products",
          value: "Products",
          sortable: false,
          center: true,
        },
        {
          key: "amount",
          value: "Amount",
          sortable: false,
          center: true,
        },
        {
          key: "quantity",
          value: "Qty",
          sortable: false,
          center: true,
        },
        {
          key: "comment",
          value: "Desc. & Comments",
          sortable: false,
        },
        {
          key: "action",
          value: "Actions",
          sortable: false,
          center: true,
        },
      ],
      formFilter: {
        tab: "",
        pageSize: 50,
        page: 1,
        sortBy: "",
        searchAttribute: "",
        searchTab: "",
        searchQuery: "",
        appId: null,
        combined: true,
      },
      formFilterByOptions: {
        regular: [
          {
            key: "systemOrderId",
            value: "System Order Number",
          },
          {
            key: "extendedOrderID",
            value: "Ebay Order Number",
          },
          {
            key: "salesRecordNumber",
            value: "Ebay SR Number",
          },
          {
            key: "buyerUserID",
            value: "Buyer Name",
          },
          {
            key: "barcode",
            value: "Item Barcode",
          },
          {
            key: "binId",
            value: "BIN Number",
          },
          {
            key: "shipmentTrackingNumber",
            value: "Tracking#",
          },
        ],
        show: [
          {
            key: "extendedOrderID",
            value: "Ebay Order Number",
          },
          {
            key: "shipmentTrackingNumber",
            value: "Tracking#",
          },
        ]
      },
      expandItems: {},
      orderApps: [],
      orderShows: [],
      tableData: [],
      systemSetting: {},
      hideCount: true,
      tabCount: {
        ready_to_ship: 0,
        completed: 0,
        flagged: 0,
        unpaid: 0,
        cancelled: 0,
      },
      onPageTabLoad: true,
      showOrdersToComplete: false,
      displayOrderItemPopup: false,
      orderItems: [],
      selectedOrderId: [],
      itemPagination: {
        page_size: 10,
        total: 1,
        page: 1,
      },
      //
      completedData: {
        orders: [],
      },
      //return order item data
      displayReturnOrderItemDialog: false,
      displayScanFormDialog: false,
      returnItemReasons: [],
      selectedReturnOrderItemId: 0,
      selectedReturnOrderId: 0,
      pageViewTagId: 'show',
      printStatus: [
        {
          id: 0,
          name: 'Awaiting Print'
        },
        {
          id: 1,
          name: 'Printed'
        }
      ],
      selectedInvoiceUrl: ''
    };
  },
  computed: {
    isReadyToShip() {
      return this.formFilter.tab === "ready_to_ship";
    },
    isCommonTab() {
      return ["ready_to_ship", "completed"].includes(this.formFilter.tab);
    },
    tabTitle() {
      let _tab = this.tabs.findIndex((m) => m.link == this.formFilter.tab);
      return _tab.value;
    },
    ebayStoreUrl() {
      return process.env.NODE_ENV === "development"
        ? "http://sandbox.ebay.com"
        : "http://ebay.com";
    }
  },
  mixins: [common],
  mounted() {
    let _vm = this;
    //auto load table page size
    _vm.formFilter.pageSize = _vm.loadPageSize();
    _vm.searchAttribute = (_vm.pageViewTagId === 'regular') ? "systemOrderId" : "extendedOrderID"
    //auto select default tab
    _vm.formFilter.tab = _vm.$route.query.tab || "ready_to_ship";
    _vm.formFilter.searchTab = _vm.formFilter.tab;
    _vm.pageViewTagId = _vm.$route.query.viewPage || "regular";
    _vm.pageViewType = (_vm.pageViewTagId === "regular") ? "Regular Orders" : "Live Show Orders"
    let findActiveTabIndex = _vm.tabs.findIndex((m) => m.link == _vm.formFilter.tab) || 0;
    _vm.$set(
      _vm.tabs,
      findActiveTabIndex,
      Object.assign(_vm.tabs[findActiveTabIndex], {
        active: true,
      })
    );
    //
    _vm.loadPageData()
    _vm.$root.$on("reload-purchase-label-data", (params) => {
      _vm.getPurchaseLabelData(params)
    });
    _vm.$root.$on("show-order-item-drawer", (params) => {
      _vm.viewOrderItems(params);
    });
    _vm.$root.$on("update-row-order", (params) => {
      _vm.tableData[params.index].localPrinted = params.attributes.localPrinted
      _vm.tableData[params.index].shipmentTrackingNumber = params.attributes.shipmentTrackingNumber
    })
    _vm.$root.$on("display-invoice", (params) => {
      _vm.selectedInvoiceUrl = params.invoiceUrl
      _vm.displayInvoicePreviewDialog = true
    });
    _vm.$root.$on("close-purchase-label-dialog", () => {
      _vm.displayPurchaseLabelDialog = false
    });
    _vm.$root.$on("reload-complete-order-dialog", (order) => {
      _vm.completeOrder(order);
    });
    _vm.$root.$on("remove-order", (id) => {
      _vm.tableData = _vm.tableData.filter((v) => v.id != id);
    });
    _vm.$root.$on("close-order-item-dialog", () => {
      _vm.displayReturnOrderItemDialog = false;
    });
    _vm.$root.$on("close-dialog", (value) => {
      _vm[value] = false;
    });
    _vm.$root.$on("remove-order-item", (params) => {
      let tableData = _vm.tableData;
      let findIndex = tableData.findIndex((v) => v.id == params.orderId);
      _vm.loadOrderItems(findIndex).then(() => {
        let OrderItems = tableData[findIndex].OrderItems.filter(
          (v) => v.auctionId != params.auctionId
        );
        _vm.tableData[findIndex].OrderItems = [...OrderItems];
        _vm.tableData[findIndex]["OrderItem.quantity"] =
          _vm.tableData[findIndex]["OrderItem.quantity"] - 1;
      });
    });
  },
  methods: {
    toggleAll() {
      const _vm = this;
      for (let i = 0; i < _vm.tableData.length; i++) {
        let _row = _vm.tableData[i];
        if (_row.extendedOrderID.length == 1) {
          _row.orderChecked = _vm.allOrdersChecked;
          //
          if (_vm.allOrdersChecked && !_vm.selectedOrders.includes(_row.orderId[0])) {
            _vm.selectedOrders.push(_row.orderId[0]);
          }
        }
      }
      //
      if (!_vm.allOrdersChecked) {
        _vm.selectedOrders = [];
      }
      _vm.showOrdersToComplete = true;
      _vm.isallOrdersIndeterminate = false;
    },
    toggleSingle(index) {
      const _vm = this;
      const _row = _vm.tableData[index];
      if (!_row.orderChecked) {
        _vm.allOrdersChecked = false;
        _vm.selectedOrders = _vm.selectedOrders.filter((v) => v != _row.orderId[0]);
      } else {
        if (!_vm.selectedOrders.includes(_row.orderId[0])) {
          _vm.selectedOrders.push(_row.orderId[0]);
        }
      }
      _vm.showOrdersToComplete = true;
    },
    isShippingOverdue(index) {
      const _vm = this,
        _row = _vm.tableData[index],
        orderHandlingTime = _vm.systemSetting.handlingTime * 24 * 3600,
        todayTimestamp = momentBusiness().isBusinessDay()
          ? moment().unix()
          : momentBusiness().nextBusinessDay().unix(),
        orderDate = _row.paidDate ? _row.paidDate : _row.createdDate,
        maxOrderHandlingTime = momentBusiness((orderDate + orderHandlingTime) * 1000)
          .nextBusinessDay()
          .endOf("day")
          .unix();
      return (
        todayTimestamp > maxOrderHandlingTime &&
        _row.complete == 0 &&
        _row.shipmentTrackingNumber == ""
      );
    },
    getShippingService(deliveryServiceSelected) {
      return typeof this.shippingServices[deliveryServiceSelected] !== "undefined"
        ? this.shippingServices[deliveryServiceSelected].description.replace(
            " ",
            "&nbsp;"
          )
        : deliveryServiceSelected;
    },
    isComplete(order) {
      return order.complete && order.ebayStatus == "completed";
    },
    getFormattedData(timestamp) {
      return moment(timestamp * 1000).format("YYYY-MM-DD HH:mm:ss");
    },
    hideItems(index) {
      this.tableData[index].OrderItems = [this.tableData[index].OrderItems[0]];
      this.tableData[index].expand = false;
    },
    expandOrderItems(orderId) {
      const _vm = this;
      return GetApiActionWithAuthorization("admin/orders/items", {
        id: orderId,
      }).then((res) => {
        const items = res.data.map((v) => {
          return {
            ...v,
            ...v.Auction,
            ...v.Auction.AuctionOwner,
          };
        });
        _vm.$set(_vm.expandItems, orderId, items);
        return items;
      });
    },
    viewOrderItems(params = {}) {
      const _vm = this;
      _vm.selectedOrderId = params.orderId;
      return GetApiActionWithAuthorization("admin/orders/items", {
        ..._vm.itemPagination,
        ...params,
        id: params.orderId,
      }).then((res) => {
        _vm.orderItems = res.data.map((v) => {
          return {
            ...v.Auction,
            AuctionAttachments: v.AuctionAttachments,
          };
        });
        _vm.itemPagination.page_size = res.page_size;
        _vm.itemPagination.total = res.count;
        if (res.data.length > 0) {
          _vm.itemPagination.page = params.page;
        }
        //
        _vm.displayOrderItemPopup = true;
      });
    },
    loadOrderItems(index) {
      const _vm = this;
      const data = _vm.tableData[index];
      return GetApiActionWithAuthorization("admin/orders/items", {
        id: data.orderId,
        excludeID: data.OrderItemID,
      }).then((res) => {
        for (const _data of res.data) {
          _vm.tableData[index].OrderItems.push({
            ..._data,
            ..._data.Auction,
            ..._data.Auction.AuctionOwner,
            ..._data.Order,
          });
        }
        //
        _vm.tableData[index].expand = true;
      });
    },
    loadOrders(params = {}) {
      let _vm = this;
      return PostApiWithAuthorizationAction("admin/orders/all", {
        filter: {
          ... _vm.formFilter,
          ... params
        },
        pageViewTagId: _vm.pageViewTagId
      }).then((res) => {
        _vm.tableData = res.data;
        _vm.shippingServices = res.services;
        _vm.orderShows = res.shows
        if (_vm.pageViewTagId == "regular") {
          if (!params.search) {
            for (const prop in res.count) {
              // eslint-disable-next-line
              if (res.count.hasOwnProperty(prop)) {
                _vm.tabCount[prop] = res.count[prop];
              }
            }
          } else {
            _vm.tabCount[_vm.formFilter.tab] = res.count[_vm.formFilter.tab];
          }
        } else {
          _vm.tabCount['all'] = res.count
        }
        _vm.selectedOrders = res.data
          .filter((v) => v.orderChecked === true)
          .map((v) => v.orderId[0]);
        //_vm.orderApps = res.stores;
        _vm.hideCount = false;
      });
    },
    loadPageData() {
      let _vm = this;
      return GetApiActionWithAuthorization("admin/orders/get-page-data").then((res) => {
        _vm.systemSetting = res.setting;
        _vm.orderApps = res.stores
        _vm.shippingOptions = res.shippingServices
        if(_vm.pageViewTagId == "regular") {
          _vm.orderApps.unshift({
            id: "",
            name: "All Stores"
          })
        }
        //set default app to NCM or first available found.
        let defaultStoreId = (_vm.pageViewTagId == "regular") ? "" : 16
        let account = _vm.$route.query.account
        if (typeof account !== "undefined") {
          let findAccount = _vm.orderApps.find(v => v.slug === account)
          if (typeof findAccount !== "undefined") {
            defaultStoreId = findAccount.id
          }
        }
        let findDefaultStore = _vm.orderApps.find(v => v.id === defaultStoreId)
        _vm.formFilter.appId = (typeof findDefaultStore !== "undefined") ? findDefaultStore.id : ((_vm.orderApps.length > 0) ? _vm.orderApps[0].id : "")
      });
    },
    preventTabClick(tab, oldTab) {
      if (typeof oldTab === "string" && oldTab.length > 1) {
        location.href = "/orders/index?tab=" + tab;
      }
      return this.onPageTabLoad && (oldTab == 0 || !oldTab);
    },
    handleTabClick() {
      this.onPageTabLoad = false;
      return this.onPageTabLoad;
    },
    hasShippingAddress(order) {
      return this.getShippingAddress(order) !== "";
    },
    getShippingAddress(order) {
      let shippingAddress = order.shippingAddress;
      shippingAddress += order.shippingCity ? "," + order.shippingCity : "";
      shippingAddress += order.shippingState ? "," + order.shippingState : "";
      shippingAddress += order.shippingPostalCode ? "," + order.shippingPostalCode : "";
      return shippingAddress;
    },
    hasVoidLabel(order) {
      return (
        (order.ebayPrinted == 0 && order.localPrinted == 0) ||
        order.status === "Awaiting Payment"
      );
    },
    editParticularOrder(order) {
      return PostApiWithAuthorizationAction("admin/orders/edit-particular-order/", {
        orders: order.OrderIds.split(','),
        shippingServiceId: order.shippingServiceId
      })
    },
    reprintPackingSlip(scope) {
      if (confirm('Are you sure that you want reprint packing slip ?')) {
        let _vm = this
        return PostApiWithAuthorizationAction("admin/orders/print-packing-slip/", {
          orders: scope.row.OrderIds.split(',')
        }).then((res) => {
          if (res.status === "success") {
            _vm.selectedInvoiceUrl = res.invoiceUrls[0]
            _vm.displayLabelPreviewDialog = false
            _vm.displayInvoicePreviewDialog = true
            _vm.displayPurchaseLabelDialog = false
          }
        })
      }
    },
    getPurchaseLabelData (params) {
      let _vm = this
      return PostApiWithAuthorizationAction("admin/orders/get-purchase-label-data/", params).then((res) => {
        if (res.status === "success") {
          _vm.purchaseLabelData = res.data
        }
        return res
      })
    },
    openPurchaseLabelDialog(scope) {
      let _vm = this
      // eslint-disable-next-line
      console.log(scope)
      this.getPurchaseLabelData({
        orders: scope.row.OrderIds.split(','),
        shippingParams: false
      }).then(res=> {
          _vm.selectedOrder = {
            ... scope.row,
            index: scope.$index,
            ... res.data.order
          }
        _vm.displayLabelPreviewDialog = false
        _vm.displayInvoicePreviewDialog = false
        _vm.displayPurchaseLabelDialog = true
      })
    },
    viewList() {
      // this.$root.$emit('display-order-items-drawer', this.binNumber)
    },
    displayLabelOnlyDialog(order) {
      // eslint-disable-next-line
      console.log(order)
      let _vm = this
      return GetApiActionWithAuthorization("admin/orders/get-shipments/" + order.id).then((res) => {
        if (res.status === "success") {
          _vm.selectedOrder = order
          _vm.selectedOrderShipmentData = res.data
          _vm.displayLabelPreviewDialog = true
          _vm.displayInvoicePreviewDialog = false
          _vm.displayPurchaseLabelDialog = false
        }
      });
    },
    displayInvoiceOnlyDialog(order) {
      let _vm = this
      return GetApiActionWithAuthorization("admin/orders/get-shipments/" + order.id).then((res) => {
        if (res.status === "success") {
          _vm.selectedInvoiceUrl = res.data[0].invoiceUrl
          // window.open(res.data[0].invoiceUrl, "_blank");
        _vm.displayLabelPreviewDialog = false
        _vm.displayInvoicePreviewDialog = true
        _vm.displayPurchaseLabelDialog = false
        }
      });
    },
    forceCompleteOrder(scope) {
      if (confirm('Are you sure that you want complete this order ?')) {
        let _vm = this;
        return PostApiWithAuthorizationAction("admin/orders/force-complete-orders", {
          orders: scope.row.OrderIds.split(',')
        }).then((res) => {
          if (res.status === "success") {
            _vm.tableData = _vm.tableData.filter((v) => v.id != scope.row.id);
          }
        });
      }
    },
    completeAllOrder() {
      let _vm = this;
      return PostApiWithAuthorizationAction("admin/orders/get-complete-data", {
        orders: _vm.selectedOrders.map((v) => v.orderId),
      }).then((res) => {
        _vm.displayCompleteOrderDialog = true;
        _vm.completedData = {
          ...res.data,
          totalOrderRemaining: _vm.selectedOrders.length,
          orderIds: _vm.tableData.filter((o) => o.orderChecked === true),
        };
      });
    },
    completeOrder(order) {
      let _vm = this;
      return PostApiWithAuthorizationAction("admin/orders/get-complete-data", {
        orders: order.orderId,
      }).then((res) => {
        if (res.status === "success") {
          _vm.displayCompleteOrderDialog = true;
          _vm.completedData = {
            ...res.data,
            orderIds: [order],
          };
        }
      });
    },
    setShippingTrackingNumber(order) {
      let _vm = this;
      return PostApiWithAuthorizationAction("admin/orders/submit-tracking-number/" + order.id).then((res) => {
        if (res.status === "success") {
          _vm.tableData = _vm.tableData.filter((v) => v.id != order.id);
        }
      });
    },
    openReturnOrderItemDialog(scope) {
      let _vm = this;
      _vm.returnItemReasons = [];
      let orderId = scope.row.orderId;
      let auctionId = scope.row.auctionId;
      return GetApiActionWithAuthorization("admin/orders/get-return-item-reasons").then(
        (res) => {
          if (res.status === "success") {
            _vm.returnItemReasons = res.data;
            _vm.selectedReturnOrderId = orderId;
            _vm.selectedReturnOrderItemId = auctionId;
            _vm.displayReturnOrderItemDialog = true;
          }
        }
      );
    },
    getTotalAmount(order) {
      const orderAmount = parseFloat(order.orderAmount)
      const totalShippingFee = parseFloat(order.totalShippingFee)
      let totalAmount = (orderAmount + totalShippingFee).toFixed(2)
      return totalAmount.replace(".00", "")
    },
    syncOrders() {
      const _vm = this
      _vm.loadingNewOrder = true
      return GetApiActionWithAuthorization("admin/orders/pull-orders").then(
        (res) => {
          if (res.status === "success") {
            _vm.loadingNewOrder = false
            location.reload()
          }
        }
      );
    },
    handlePageAction(viewType) {
      //this.pageViewType = viewType
      const pageViewTagId = (viewType === 'Live Show Orders') ? 'show' : 'regular'
      location.href = '/orders/index?viewPage=' + pageViewTagId
    },
    openPurchasePrintAllDialog() {},
    openScanFormDialog() {
      this.displayScanFormDialog = true
    },
    searchOrders(searchAttribute) {
      this.loadOrders({
        ... this.defaultPaginationParams,
        searchAttribute,
        searchQuery: this.formFilter[searchAttribute]
      })
    }
  },
  watch: {
    "formFilter.page": function (newValue) {
      this.loadOrders({
        page: newValue,
      });
    },
    "formFilter.appId": function (appId) {
      const defaultPaginationParams = this.defaultPaginationParams
      this.loadOrders({
        ...defaultPaginationParams,
        appId
      })
    }
  },
};
</script>

<template>
  <div class="order-listing-page">
    <!-- Generate Scan Form Dialog -->
    <ScanFormDialog     
      :displayDialog="displayScanFormDialog"
      :pageViewTagId="pageViewTagId"
    />
    <!-- Print Shipping Label Dialog -->
    <PurchaseLabelDialog
      :displayDialog="displayPurchaseLabelDialog"
      :data="selectedOrder"
      :purchaseLabelData="purchaseLabelData"
    />
    <!-- Display Label Preview Dialog -->
    <DisplayLabelPreviewDialog
      :displayDialog="displayLabelPreviewDialog"
      :order="selectedOrder"
      :data="selectedOrderShipmentData"
    />
    <!-- Display Invoice Preview Dialog -->
    <InvoicePreviewDialog
      :displayDialog="displayInvoicePreviewDialog"
      :invoiceUrl="selectedInvoiceUrl"
    />
    <!-- Complete Orders Dialog -->
    <CompleteOrderDialog
      :systemSetting="systemSetting"
      :displayDialog="displayCompleteOrderDialog"
      :data="completedData"
    />
    <!-- Return Order Item Dialog -->
    <ReturnOrderItemDialog
      :reasons="returnItemReasons"
      :displayDialog="displayReturnOrderItemDialog"
      :productId="selectedReturnOrderItemId"
      :orderId="selectedReturnOrderId"
    />
    <el-drawer
      ref="orderItemDrawer"
      :title="'ORDER ITEMS'"
      :visible.sync="displayOrderItemPopup"
      :close-on-press-escape="false"
      :with-header="true"
      :wrapperClosable="false"
      size="70%"
      :append-to-body="true"
      custom-class="common-drawer demo-drawer"
    >
      <ViewOrderItemList
        :items="orderItems"
        :orderId="selectedOrderId"
        :pagination="itemPagination"
      />
    </el-drawer>
    <Layout>
      <PageHeader :title="title" :subTitle="tabTitle" :items="items" icon="fas fa-gem" />
      <div class="order-page-container" style="margin-top: -20px">
        <el-row>
          <el-col
            :xs="24"
            :sm="4"
            :md="4"
            :lg="4"
            :xl="4"
            class="pt-2">
            <el-dropdown @command="handlePageAction">
              <el-button type="primary">
                 {{ pageViewType }}<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="Live Show Orders">
                  Live Show Orders
                </el-dropdown-item>
                <el-dropdown-item command="Regular Orders">
                  Regular Orders
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <!--b-button
              :disabled="loadingNewOrder"
              variant="primary"
              @click="syncOrders()"
              block>
              <i class="fas fa-sync font-size-16" v-if="!loadingNewOrder"></i>
              <i class="el-icon-loading" v-else></i>
              &nbsp;Pull New Ebay Orders
            </b-button-->
          </el-col>
          <el-col :xs="24" :sm="20" :md="20" :lg="20" :xl="20">
            <div class="filter-row text-right">
              <div class="">
                <el-form
                  ref="form"
                  :model="formFilter"
                  :inline="true"
                  @submit.native.prevent="loadOrders({ ...defaultPaginationParams, search: true })"
                  class="form-inline-custom mb-0"
                >
                  <el-form-item>
                    <el-input
                      :placeholder="'Filter Orders By'"
                      style="width: 300px"
                      v-model="formFilter.searchQuery"
                      clearable
                    >
                    </el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-model="formFilter.searchAttribute"
                      placeholder="Filter Type"
                    >
                      <el-option
                        v-for="(option, index) in formFilterByOptions[pageViewTagId]"
                        :key="index"
                        :label="option.value"
                        :value="option.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item v-if="pageViewTagId != 'show'">
                    <el-select v-model="formFilter.searchTab" placeholder="Orders Status">
                      <el-option
                        v-for="(option, index) in tabs"
                        :key="index"
                        :label="option.value"
                        :value="option.link"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item style="margin-right: 0" class="pt-2">
                    <el-button
                      type="success"
                      native-type="submit"
                      icon="el-icon-search"
                      circle
                    ></el-button>
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </el-col>
        </el-row>
            <div class="data-table" v-if="pageViewTagId === 'show'">
                <b-row class="mx-0" style="width: 85%; margin: auto !important;">
                  <b-col cols="2" class="px-0">
                    <el-select
                      v-model="formFilter.appId"
                      placeholder="Stores"
                      @change="searchOrders('appId')"
                      class="mx-0"
                      style="width: 100% !important"
                    >
                      <el-option
                        v-for="(orderApp, index) in orderApps"
                        :key="index"
                        :label="orderApp.name"
                        :value="orderApp.id"
                      ></el-option>
                    </el-select>
                  </b-col>
                  <b-col cols="2">
                    <el-select
                      v-model="formFilter.localPrinted"
                      placeholder="Print Status"
                      @change="searchOrders('localPrinted')"
                      class="mx-0"
                      style="width: 100% !important"
                    >
                      <el-option
                        v-for="(p, index) in printStatus"
                        :key="index"
                        :label="p.name"
                        :value="p.id"
                      ></el-option>
                    </el-select>
                  </b-col>
                  <b-col cols="1">
                    <el-select
                      v-model="formFilter.showId"
                      placeholder="Show#"
                      @change="searchOrders('showId')"
                      class="mx-0"
                      style="width: 100% !important"
                    >
                      <el-option
                        v-for="(v, index) in orderShows"
                        :key="index"
                        :label="v"
                        :value="v"
                      ></el-option>
                    </el-select>
                  </b-col>
                  <b-col cols="6" class="text-center">
                    <el-form
                      ref="form"
                      :model="formFilter"
                      :inline="true"
                      class="form-inline-custom mb-0"
                      style="font-size: 16px"
                    >
                      <b-button
                        variant="success"
                        @click="openPurchasePrintAllDialog()"
                        class="mx-1"
                        v-if="isReadyToShip"
                      >
                        <i class="fas fa-print font-size-16"></i> PURCHASE & PRINT ALL
                      </b-button>
                      <b-button
                        variant="secondary"
                        @click="openScanFormDialog()"
                        class="m-1"
                        v-if="isReadyToShip"
                      >
                        <i class="fas fa-barcode font-size-16"></i> SCAN FORM
                      </b-button>
                    </el-form>
                </b-col>
                <b-col cols="3" class="pt-1 text-right">
                  <div class="dataTables_paginate paging_simple_numbers">
                    <ul
                      class="pagination pagination-rounded mb-0"
                      style="justify-content: center"
                    >
                      <b-pagination
                        v-model="formFilter.page"
                        :total-rows="tabCount['all']"
                        :per-page="formFilter.pageSize"
                      ></b-pagination>
                    </ul>
                  </div>
                </b-col>
              </b-row>
              <div class="table-responsive mb-0">
                <el-table
                  :data="tableData"
                  header-align="center"
                  :empty-text="' '"
                  class="my-1 el-table-effect el-table-effect-show"
                  stripe
                >
                  <!--el-table-column
                    width="35"
                    v-if="formFilter.tab == 'ready_to_ship'">
                    <template slot="header">
                      <b-form-checkbox
                        v-model="allOrdersChecked"
                        @change="toggleAll"
                      ></b-form-checkbox>
                    </template>
                    <template slot-scope="scope">
                      <b-form-checkbox
                        v-model="scope.row.orderChecked"
                        v-if="scope.row.extendedOrderID.length == 1"
                        @change="toggleSingle(scope.$index)"
                      ></b-form-checkbox>
                      <i class="fas fa-compress" v-else></i>
                    </template>
                  </el-table-column-->
                  <el-table-column
                    label="Order #"
                    width="220"
                    class="order-number-column">
                    <template slot-scope="scope">
                      <div v-if="formFilter.tab !== 'unpaid'">
                        <div style="color: red" v-if="isShippingOverdue(scope.$index)">
                          <i class="fas fa-robot"></i>
                          <span style="font-size: 14px">Shipping Overdue</span>
                        </div>
                      </div>
                      <div>
                        <div class="mb-1">
                          <el-tag
                            type="info"
                            effect="dark"
                            :style="{ backgroundColor: scope.row.Application.color }"
                            size="mini"
                          >
                            {{ scope.row.Application.name }}
                          </el-tag>
                          <el-tag
                            type="danger"
                            effect="dark"
                            size="mini"
                            style="margin-left: 5px;cursor: pointer;"
                          >
                            Show: <b>{{ scope.row.Application.sku + scope.row.showId }}</b>
                          </el-tag>
                        </div>
                        <div
                          class=""
                          v-if="scope.row.extendedOrderID.length === 1">
                          <el-link
                            :underline="false"
                            type="primary"
                            target="_blank"
                            :href="
                              ebayStoreUrl +
                              '/' +
                              'sh/ord/details?srn=' +
                              scope.row.salesRecordNumber[0] +
                              '&orderid=' +
                              scope.row.extendedOrderID[0]
                            "
                          >
                            {{ scope.row.extendedOrderID[0] }}
                          </el-link>
                        </div>
                        <el-button-group v-else>
                          <el-button
                            type="primary"
                            size="small"
                            class="mb-0"
                            @click="viewOrderOnEbay(ebayStoreUrl + '/sh/ord/details?srn=' + scope.row.salesRecordNumber[0] + '&orderid=' + scope.row.extendedOrderID[0])">
                            {{ scope.row.extendedOrderID[0] }}
                          </el-button>
                      <el-popover
                        placement="bottom"
                        title="Combined Orders"
                        width="180"
                        popper-class="order-amount-popover"
                        :visible-arrow="true"
                        trigger="click"
                      >
                        <div
                          v-for="(extendedOrderID, index) in scope.row.extendedOrderID"
                          :key="index"
                        >
                          <div class="el-popover-item-line text-center">
                            <el-link
                              :underline="false"
                              type="danger"
                              class="font-weight-bold"
                              target="_blank"
                              v-if="extendedOrderID != ''"
                              :href="
                                ebayStoreUrl +
                                '/' +
                                'sh/ord/details?srn=' +
                                scope.row.salesRecordNumber[index] +
                                '&orderid=' +
                                extendedOrderID
                              "
                            >
                              {{ extendedOrderID }}
                            </el-link>
                          </div>
                          <hr style="margin: 2px" class="mx-1" />
                        </div>
                            <el-button type="primary" size="small" class="mb-0" slot="reference">
                              <i class="el-dropdown__icon el-icon-arrow-down"></i>
                            </el-button>
                      </el-popover>
                        </el-button-group>
                        <div class="" v-if="scope.row.OrderBuyer">
                          <el-tooltip
                            class="item display-inline"
                            effect="dark"
                            :content="
                              scope.row.OrderBuyer.firstname +
                              ' ' +
                              scope.row.OrderBuyer.lastname +
                              ' has already bought some items from us.'
                            "
                            placement="top-start"
                            v-if="scope.row.buyerOrdersCount > 1"
                          >
                            <i class="fas fa-star" style="color: #a0ec1b"></i>
                          </el-tooltip>
                          <el-link
                            class="display-inline font-weight-400"
                            :underline="false"
                            type="primary"
                            target="_blank"
                            :href="ebayStoreUrl + '/usr/' + scope.row.buyerUserID"
                          >
                            {{ scope.row.OrderBuyer.firstname }}
                            {{ scope.row.OrderBuyer.lastname }}
                          </el-link>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="Products" min-width="330">
                    <template slot-scope="scope">
                      <el-table
                        :data="scope.row.OrderItems"
                        style="width: 100%"
                        class="order-items-table px-1"
                        :show-header="false"
                      >
                        <el-table-column style="border-bottom: none;">
                          <template slot-scope="productScope" min-width="350">
                            <a
                              target="_blank"
                              :href="ebayStoreUrl + '/' + 'itm/' + productScope.row.ebayId"
                              style="color: #4c9df0;font-weight: bold !important">{{ productScope.row.title.split(' ')[0] }}</a> {{ productScope.row.title.split(' ').slice(1).join(' ') }}&nbsp;<small
                              style="font-style: italic; font-weight: bold"
                              v-if="scope.row.extendedOrderID.length > 1"
                              >-&nbsp;{{ productScope.row.itemExtendedOrderID }} </small>
                          </template>
                        </el-table-column>
                        <!--el-table-column width="70">
                          <template slot-scope="productScope">
                            <span class="font-weight-bold" style="color: red">
                              B {{ formatBinNumber(productScope.row.binId) }}
                            </span>
                          </template>
                        </el-table-column>
                        <el-table-column width="70">
                          <template slot-scope="productScope">
                            <div class="">
                              <el-link
                                :underline="false"
                                type="primary"
                                class="font-weight-bold"
                                target="_blank"
                                :href="
                                  ebayStoreUrl + '/' + 'itm/' + productScope.row.ebayId
                                "
                              >
                                {{ productScope.row.barcode }}
                              </el-link>
                            </div>
                            <div class="text-center">
                              <el-tooltip
                                class="item"
                                effect="dark"
                                content="Relist Item"
                                placement="top-start"
                              >
                                <el-button
                                  size="mini"
                                  type="danger"
                                  @click="openReturnOrderItemDialog(productScope)"
                                  circle
                                >
                                  <i
                                    class="el-icon-refresh-left font-size-16 font-weight-bold"
                                  />
                                </el-button>
                              </el-tooltip>
                            </div>
                          </template>
                        </el-table-column-->
                      </el-table>
                      <div
                        class="pt-1 text-right"
                        v-if="scope.row['OrderItem.quantity'] > 1"
                      >
                        <span
                          class="expand"
                          @click.once="loadOrderItems(scope.$index)"
                          v-if="!scope.row.expand"
                        >
                          [+] <span class="text">Expand</span>
                        </span>
                        <span class="hide" v-else @click.once="hideItems(scope.$index)"
                          >[-] <span class="text">Hide</span>
                        </span>
                      </div>
                      <div
                        v-if="scope.row.shipmentTrackingNumber != ''"
                        class="my-1">
                        <el-tag
                          type="success"
                          effect="dark"
                          size="small"
                          class="mr-1"
                        >
                          Printed
                        </el-tag>
                        <b>Track. #:</b> <el-tag
                          type="primary"
                          effect="dark"
                          size="small"
                          style="cursor: pointer;"
                        >
                          {{ scope.row.shipmentTrackingNumber }}
                        </el-tag>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="Amount" min-width="40">
                    <template slot-scope="scope">
                      <el-popover
                        placement="right"
                        title="Amount"
                        width="300"
                        popper-class="order-amount-popover"
                        :visible-arrow="true"
                        trigger="click"
                      >
                        <div
                          v-for="(extendedOrderID, index) in scope.row.extendedOrderID"
                          :key="index"
                        >
                          <div class="el-popover-item-line">
                            <el-link
                              :underline="false"
                              type="primary"
                              class="font-weight-bold"
                              target="_blank"
                              v-if="extendedOrderID != ''"
                              :href="
                                ebayStoreUrl +
                                '/' +
                                'sh/ord/details?srn=' +
                                scope.row.salesRecordNumber[index] +
                                '&orderid=' +
                                extendedOrderID
                              "
                            >
                              {{ extendedOrderID }}
                            </el-link>
                            <el-link
                              :underline="false"
                              type="primary"
                              class="font-weight-bold"
                              target="_blank"
                              v-else-if="scope.row.salesRecordNumber[index] > 0"
                              :href="
                                ebayStoreUrl +
                                '/' +
                                'sh/ord/details?srn=' +
                                scope.row.salesRecordNumber[index] +
                                '&transid=0'
                              "
                            >
                              {{ scope.row.salesRecordNumber[index] }}
                            </el-link>
                            <el-link
                              :underline="false"
                              type="primary"
                              class="font-weight-bold"
                              v-else
                              href="javascript:;"
                            >
                              {{ "SJ-" + scope.row.orderId[index] }} </el-link
                            >: ${{ scope.row.total[index] }}
                            <el-link
                              class="expand-item"
                              :underline="false"
                              type="danger"
                              @click="expandOrderItems(scope.row.orderId[index])"
                              v-if="!expandItems[scope.row.orderId[index]]"
                            >
                              [+]
                            </el-link>
                            <ul
                              class="pl-2 mb-0"
                              v-if="expandItems[scope.row.orderId[index]]"
                            >
                              <li
                                v-for="(orderItem, _index) in expandItems[
                                  scope.row.orderId[index]
                                ]"
                                :key="_index"
                                style="
                                  font-style: italic;
                                  font-weight: 300;
                                  list-style-type: square;
                                "
                              >
                                {{ orderItem.totalQuantity }}x {{ orderItem.barcode }} (B
                                {{ formatBinNumber(orderItem.binId) }}) : ${{
                                  orderItem.totalPurchasedPrice
                                }}
                              </li>
                            </ul>
                          </div>
                          <div class="el-popover-item-line" style="font-size: 0.8rem">
                            Discount: {{ "$" + scope.row.discountPrice[index] }}
                          </div>
                          <div class="el-popover-item-line" style="font-size: 0.8rem">
                            Shipping Fee:
                            {{
                              scope.row.shippingServiceCost[index] == 0
                                ? "Free"
                                : "$" + scope.row.shippingServiceCost[index]
                            }}
                          </div>
                          <hr style="margin: 2px" class="mx-1" />
                        </div>
                        <div class="text-center">
                          <small class="px-2"
                            ><i>Ebay Order amount may include also some taxes.</i></small
                          >
                        </div>
                        <el-button type="success" size="small" slot="reference">
                          ${{ getTotalAmount(scope.row) }}
                        </el-button>
                      </el-popover>
                    </template>
                  </el-table-column>
                  <el-table-column label="Qty" min-width="40">
                    <template slot-scope="scope">
                      <el-button
                        type="info"
                        size="small"
                        @click="
                          viewOrderItems({
                            ...itemPagination,
                            orderId: scope.row.orderId,
                          })
                        "
                      >
                        {{ scope.row["OrderItem.quantity"] }}
                      </el-button>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="Actions"
                    min-width="90"
                    align="center"
                    class-name="action-column"
                    header-align="center"
                  >
                    <template slot-scope="scope">
                      <div
                        v-if="isCommonTab"
                        class="text-center">
                        <el-tooltip
                          v-if="scope.row.localPrinted == 0"
                          class="item"
                          effect="dark"
                          content="Print Shipping Label From STAMPS"
                          placement="top-start"
                        >
                          <el-button
                            type="bs-success-dark"
                            icon="fas fa-print"
                            class="mr-1 mb-1"
                            @click="openPurchaseLabelDialog(scope)"
                            circle
                          >
                          </el-button>
                        </el-tooltip>
                        <el-tooltip
                          v-if="!isComplete(scope.row) && scope.row.localPrinted == 1"
                          class="item"
                          effect="dark"
                          content="Complete Order"
                          placement="top-start"
                        >
                          <el-button
                            @click="forceCompleteOrder(scope)"
                            type="danger"
                            icon="fas fa-qrcode"
                            class="mb-1 mr-1"
                            circle
                          >
                          </el-button>
                        </el-tooltip>
                        <el-tooltip
                          v-if="!hasVoidLabel(scope.row)"
                          class="item"
                          effect="dark"
                          content="Print Label Only"
                          placement="top-start"
                        >
                          <el-button
                            @click="displayLabelOnlyDialog(scope.row)"
                            type="bs-success-deep"
                            icon="fas fa-sticky-note"
                            class="mr-1 mb-1"
                            circle
                          >
                          </el-button>
                        </el-tooltip>
                        <el-tooltip
                          v-if="!hasVoidLabel(scope.row)"
                          class="item"
                          effect="dark"
                          content="Print Invoice Only"
                          placement="top-start"
                        >
                          <el-button
                            @click="displayInvoiceOnlyDialog(scope.row)"
                            type="bs-primary-dark"
                            icon="fas fa-file-invoice"
                            class="mr-1 mb-1"
                            circle
                          >
                          </el-button>
                        </el-tooltip>
                        <el-tooltip
                          v-if="!hasVoidLabel(scope.row)"
                          class="item"
                          effect="dark"
                          content="RePrint Packing Slip"
                          placement="top-start"
                        >
                          <el-button
                            type="bs-success-dark"
                            icon="fas fa-print"
                            class="mr-1 mb-1"
                            @click="reprintPackingSlip(scope)"
                            circle
                          >
                          </el-button>
                        </el-tooltip>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="dataTables_paginate paging_simple_numbers mt-2">
                <ul
                  class="pagination pagination-rounded mb-0"
                  style="justify-content: center"
                >
                  <b-pagination
                    v-model="formFilter.page"
                    :total-rows="tabCount['all']"
                    :per-page="formFilter.pageSize"
                  ></b-pagination>
                </ul>
              </div>
            </div>
        <el-tabs
          ref="tableOrders"
          type="border-card"
          v-else
          v-model="formFilter.tab"
          :before-leave="preventTabClick"
          @tab-click="handleTabClick"
          stretch
        >
          <el-tab-pane
            v-for="tab in tabs"
            :key="tab.link"
            :active="tab.active"
            :name="tab.link"
          >
            <template #label>
              <a :href="'/orders/index?tab=' + tab.link" class="product-tab-link">
                <i :class="['font-size-16', tab.icon]"></i> {{ tab.value }}
                <span :id="tab.link + '-count'" class="tab-span-count">{{
                  !hideCount ? tabCount[tab.link] : ""
                }}</span>
              </a>
            </template>
            <div class="data-table" v-if="tab.link == formFilter.tab">
                <b-row class="mx-0">
                  <b-col cols="3">
                    <label class="pt-2" v-if="isReadyToShip">Combined Orders: </label>
                    <el-switch
                      v-model="formFilter.combined"
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                      class="mx-2"
                      @change="loadOrders({ ...defaultPaginationParams })"
                      v-if="isReadyToShip"
                    >
                    </el-switch>
                  </b-col>
                  <b-col cols="6" class="text-center">
                  <el-form
                    ref="form"
                    :model="formFilter"
                    :inline="true"
                    class="form-inline-custom mb-0"
                    style="font-size: 16px"
                  >
                    <b-button
                      variant="warning"
                      @click="scanOrder()"
                      class="mx-1"
                      v-if="isReadyToShip"
                    >
                      <i class="fas fa-qrcode font-size-16"></i> SCAN ORDER
                    </b-button>
                    <b-button
                      variant="info"
                      @click="completeAllOrder()"
                      class="mx-1"
                      :disabled="selectedOrders.length == 0"
                      v-if="isReadyToShip"
                    >
                      <i class="fas fa-qrcode font-size-16"></i> COMPLETE ALL
                      <span v-if="showOrdersToComplete"
                        >({{ selectedOrders.length }})</span
                      >
                    </b-button>
                    <b-button
                      variant="success"
                      @click="completeOrder()"
                      class="mx-1"
                      v-if="isReadyToShip"
                    >
                      <i class="fas fa-print font-size-16"></i> PURCHASE & PRINT ALL
                    </b-button>
                    <b-button
                      variant="secondary"
                      @click="openScanFormDialog()"
                      class="m-1"
                      v-if="isReadyToShip"
                    >
                      <i class="fas fa-barcode font-size-16"></i> SCAN FORM
                    </b-button>
                  </el-form>
                </b-col>
                <b-col cols="3" class="pt-1 text-right">
                  <!--el-radio-group v-model="formFilter.appId">
                    <el-radio-button
                      :label="orderApp.id"
                      v-for="orderApp in orderApps"
                      :key="orderApp.id"
                      style="text-transform: uppercase;">
                      {{ orderApp.name }}
                    </el-radio-button>
                  </el-radio-group-->
                  <el-select
                    v-model="formFilter.appId"
                    placeholder="Stores"
                    @change="searchOrders('appId')"
                    class="mx-1"
                    style="width: auto !important"
                  >
                    <el-option
                      v-for="(orderApp, index) in orderApps"
                      :key="index"
                      :label="orderApp.name"
                      :value="orderApp.id"
                    ></el-option>
                  </el-select>
                </b-col>
              </b-row>
              <div class="table-responsive mb-0">
                <el-table
                  :data="tableData"
                  style="width: 100%"
                  header-align="center"
                  :empty-text="' '"
                  class="my-1 el-table-effect el-table-effect-regular"
                  stripe
                >
                  <el-table-column
                    width="35"
                    v-if="formFilter.tab == 'ready_to_ship'">
                    <template slot="header">
                      <b-form-checkbox
                        v-model="allOrdersChecked"
                        @change="toggleAll"
                      ></b-form-checkbox>
                    </template>
                    <template slot-scope="scope">
                      <b-form-checkbox
                        v-model="scope.row.orderChecked"
                        v-if="scope.row.extendedOrderID.length == 1"
                        @change="toggleSingle(scope.$index)"
                      ></b-form-checkbox>
                      <i class="fas fa-compress" v-else></i>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="Order #"
                    width="165"
                    class="order-number-column">
                    <template slot-scope="scope">
                      <div v-if="formFilter.tab !== 'unpaid'">
                        <div v-if="scope.row.shipmentTrackingNumber === ''">
                          <el-tooltip
                            v-if="scope.row.requireConfigurationUpdate == 1"
                            class="item"
                            effect="dark"
                            placement="right"
                          >
                            <div style="color: red" class="blink">
                              <i class="fas fa-robot"></i
                              ><span style="font-size: 14px"> Errors detected</span>
                            </div>
                            <div slot="content">
                              Some errors have been found while checking the print label
                              configuration.<br />
                              Please fix it before purchase a label for that order.
                            </div>
                          </el-tooltip>
                        </div>
                        <div style="color: red" v-if="isShippingOverdue(scope.$index)">
                          <i class="fas fa-robot"></i>
                          <span style="font-size: 14px">Shipping Overdue</span>
                        </div>
                        <el-tag
                          size="mini"
                          effect="dark"
                          type="danger"
                          v-if="scope.row.status === 'Cancelled'"
                        >
                          Cancelled
                        </el-tag>
                      </div>
                      <div>
                        <div class="mb-1">
                          <el-tag
                            type="info"
                            effect="dark"
                            :style="{ backgroundColor: scope.row.Application.color }"
                            size="mini"
                          >
                            {{ scope.row.Application.name }}
                          </el-tag>
                        </div>
                        <div class="mb-1" v-if="scope.row.systemOrderId">
                          <span style="font-weight: 600; font-style: italic">
                            {{ scope.row.systemOrderId }}
                          </span>
                        </div>
                        <div
                          v-for="(extendedOrderID, index) in scope.row.extendedOrderID"
                          :key="index"
                        >
                          <div class="" v-if="extendedOrderID != ''">
                            <el-link
                              :underline="false"
                              type="primary"
                              target="_blank"
                              :href="
                                ebayStoreUrl +
                                '/' +
                                'sh/ord/details?srn=' +
                                scope.row.salesRecordNumber[index] +
                                '&orderid=' +
                                extendedOrderID
                              "
                            >
                              {{ extendedOrderID }}
                            </el-link>
                          </div>
                          <div class="" v-if="scope.row.salesRecordNumber[index] > 0">
                            <el-link
                              :underline="false"
                              type="primary"
                              target="_blank"
                              :href="
                                ebayStoreUrl +
                                '/' +
                                'sh/ord/details?srn=' +
                                scope.row.salesRecordNumber[index] +
                                '&transid=0'
                              "
                            >
                              {{ scope.row.salesRecordNumber[index] }}
                            </el-link>
                          </div>
                          <div class="" v-else>
                            <el-link
                              :underline="false"
                              type="primary"
                              href="javascript:;"
                            >
                              {{ "SJ-" + scope.row.orderId[index] }}
                            </el-link>
                          </div>
                          <hr
                            style="margin: 0"
                            v-if="scope.row.extendedOrderID.length > 1"
                          />
                        </div>
                        <div
                          class="order_tracking_number"
                          v-if="scope.row.shipmentTrackingNumber != ''"
                        >
                          <el-link
                            :underline="false"
                            type="primary"
                            target="_blank"
                            :href="
                              'https://jewelgiant.com/tracking/' +
                              scope.row.shipmentTrackingNumber
                            "
                          >
                            {{ scope.row.shipmentTrackingNumber }}
                          </el-link>
                          <el-button
                            type="danger"
                            size="small"
                          >
                          Reprint Label
                          </el-button>
                        </div>
                        <div class="" v-if="scope.row.OrderBuyer">
                          <el-tooltip
                            class="item display-inline"
                            effect="dark"
                            :content="
                              scope.row.OrderBuyer.firstname +
                              ' ' +
                              scope.row.OrderBuyer.lastname +
                              ' has already bought some items from us.'
                            "
                            placement="top-start"
                            v-if="scope.row.buyerOrdersCount > 1"
                          >
                            <i class="fas fa-star" style="color: #a0ec1b"></i>
                          </el-tooltip>
                          <el-link
                            class="display-inline font-weight-400"
                            :underline="false"
                            type="primary"
                            target="_blank"
                            :href="ebayStoreUrl + '/usr/' + scope.row.buyerUserID"
                          >
                            {{ scope.row.OrderBuyer.firstname }}
                            {{ scope.row.OrderBuyer.lastname }}
                          </el-link>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="Products" min-width="330">
                    <template slot-scope="scope">
                      <el-table
                        :data="scope.row.OrderItems"
                        style="width: 100%"
                        class="order-items-table px-1"
                        :show-header="false"
                      >
                        <el-table-column>
                          <template slot-scope="productScope" min-width="350">
                            {{ productScope.row.title }}&nbsp;<small
                              style="font-style: italic; font-weight: bold"
                              v-if="scope.row.extendedOrderID.length > 1"
                              >-&nbsp;{{ productScope.row.itemExtendedOrderID }} </small
                            >-&nbsp;
                            <span class="owner-fullname font-weight-bold"
                              >{{ productScope.row.firstName }}&nbsp;{{
                                productScope.row.lastName[0] + "."
                              }}</span
                            >
                          </template>
                        </el-table-column>
                        <el-table-column width="70">
                          <template slot-scope="productScope">
                            <span class="font-weight-bold" style="color: red">
                              B {{ formatBinNumber(productScope.row.binId) }}
                            </span>
                          </template>
                        </el-table-column>
                        <el-table-column width="70">
                          <template slot-scope="productScope">
                            <div class="">
                              <el-link
                                :underline="false"
                                type="primary"
                                class="font-weight-bold"
                                target="_blank"
                                :href="
                                  ebayStoreUrl + '/' + 'itm/' + productScope.row.ebayId
                                "
                              >
                                {{ productScope.row.barcode }}
                              </el-link>
                            </div>
                            <div class="text-center">
                              <el-tooltip
                                class="item"
                                effect="dark"
                                content="Relist Item"
                                placement="top-start"
                              >
                                <el-button
                                  size="mini"
                                  type="danger"
                                  @click="openReturnOrderItemDialog(productScope)"
                                  circle
                                >
                                  <i
                                    class="el-icon-refresh-left font-size-16 font-weight-bold"
                                  />
                                </el-button>
                              </el-tooltip>
                            </div>
                          </template>
                        </el-table-column>
                      </el-table>
                      <div
                        class="pt-1 text-right"
                        v-if="scope.row['OrderItem.quantity'] > 1"
                      >
                        <span
                          class="expand"
                          @click.once="loadOrderItems(scope.$index)"
                          v-if="!scope.row.expand"
                        >
                          [+] <span class="text">Expand</span>
                        </span>
                        <span class="hide" v-else @click="hideItems(scope.$index)"
                          >[-] <span class="text">Hide</span>
                        </span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="Amount" min-width="90">
                    <template slot-scope="scope">
                      <el-popover
                        placement="right"
                        title="Amount"
                        width="300"
                        popper-class="order-amount-popover"
                        :visible-arrow="true"
                        trigger="click"
                      >
                        <div
                          v-for="(extendedOrderID, index) in scope.row.extendedOrderID"
                          :key="index"
                        >
                          <div class="el-popover-item-line">
                            <el-link
                              :underline="false"
                              type="primary"
                              class="font-weight-bold"
                              target="_blank"
                              v-if="extendedOrderID != ''"
                              :href="
                                ebayStoreUrl +
                                '/' +
                                'sh/ord/details?srn=' +
                                scope.row.salesRecordNumber[index] +
                                '&orderid=' +
                                extendedOrderID
                              "
                            >
                              {{ extendedOrderID }}
                            </el-link>
                            <el-link
                              :underline="false"
                              type="primary"
                              class="font-weight-bold"
                              target="_blank"
                              v-else-if="scope.row.salesRecordNumber[index] > 0"
                              :href="
                                ebayStoreUrl +
                                '/' +
                                'sh/ord/details?srn=' +
                                scope.row.salesRecordNumber[index] +
                                '&transid=0'
                              "
                            >
                              {{ scope.row.salesRecordNumber[index] }}
                            </el-link>
                            <el-link
                              :underline="false"
                              type="primary"
                              class="font-weight-bold"
                              v-else
                              href="javascript:;"
                            >
                              {{ "SJ-" + scope.row.orderId[index] }} </el-link
                            >: ${{ scope.row.total[index] }}
                            <el-link
                              class="expand-item"
                              :underline="false"
                              type="danger"
                              @click="expandOrderItems(scope.row.orderId[index])"
                              v-if="!expandItems[scope.row.orderId[index]]"
                            >
                              [+]
                            </el-link>
                            <ul
                              class="pl-2 mb-0"
                              v-if="expandItems[scope.row.orderId[index]]"
                            >
                              <li
                                v-for="(orderItem, _index) in expandItems[
                                  scope.row.orderId[index]
                                ]"
                                :key="_index"
                                style="
                                  font-style: italic;
                                  font-weight: 300;
                                  list-style-type: square;
                                "
                              >
                                {{ orderItem.totalQuantity }}x {{ orderItem.barcode }} (B
                                {{ formatBinNumber(orderItem.binId) }}) : ${{
                                  orderItem.totalPurchasedPrice
                                }}
                              </li>
                            </ul>
                          </div>
                          <div class="el-popover-item-line" style="font-size: 0.8rem">
                            Discount: {{ "$" + scope.row.discountPrice[index] }}
                          </div>
                          <div class="el-popover-item-line" style="font-size: 0.8rem">
                            Shipping Fee:
                            {{
                              scope.row.shippingServiceCost[index] == 0
                                ? "Free"
                                : "$" + scope.row.shippingServiceCost[index]
                            }}
                          </div>
                          <hr style="margin: 2px" class="mx-1" />
                        </div>
                        <div class="text-center">
                          <small class="px-2"
                            ><i>Ebay Order amount may include also some taxes.</i></small
                          >
                        </div>
                        <el-button type="success" size="small" slot="reference">
                          ${{ getTotalAmount(scope.row) }}
                        </el-button>
                      </el-popover>
                    </template>
                  </el-table-column>
                  <el-table-column label="Qty" min-width="60">
                    <template slot-scope="scope">
                      <el-button
                        type="info"
                        size="small"
                        @click="
                          viewOrderItems({
                            ...itemPagination,
                            orderId: scope.row.orderId,
                          })
                        "
                      >
                        {{ scope.row["OrderItem.quantity"] }}
                      </el-button>
                    </template>
                  </el-table-column>
                  <el-table-column label="Notes" min-width="180">
                    <template slot-scope="scope">
                      <div class="top-note" style="font-size: 13px">
                        <div class="note-shipping-weight">
                          <span>Shipping Weight</span> :
                          <span
                            ><b>{{ scope.row.defaultShippingWeight }}oz</b></span
                          >
                        </div>
                        <div class="note-package-type">
                          <span>Package Type</span> :
                          <span
                            ><b>{{ scope.row.defaultPackageType }}</b></span
                          >
                        </div>
                        <div class="note-package-weight">
                          <span>Package Weight</span> :
                          <span
                            ><b>{{ scope.row.defaultPackageWeight }}oz</b></span
                          >
                        </div>
                        <div class="note-delivery-service">
                          <span>Delivery Service</span> :
                          <span
                            ><b
                              v-html="
                                getShippingService(scope.row.deliveryServiceSelected)
                              "
                            ></b
                          ></span>
                        </div>
                        <div class="note-shipping-service">
                          <el-select
                            v-model="scope.row.shippingServiceId"
                            placeholder="Shipping Services"
                            @change="editParticularOrder(scope.row)"
                            class="mx-0"
                            style="width: 100% !important"
                          >
                            <el-option
                              v-for="(service, index) in shippingOptions"
                              :key="index"
                              :label="service.name"
                              :value="service.id"
                            ></el-option>
                          </el-select>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="Date Created" min-width="100">
                    <template slot-scope="scope">
                      <span
                        v-html="
                          getFormattedData(scope.row.createdDate).replace(' ', '<br/>')
                        "
                      ></span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="Actions"
                    min-width="145"
                    align="center"
                    class-name="action-column"
                    header-align="center"
                  >
                    <template slot-scope="scope">
                      <div v-if="isCommonTab" style="min-height: 120px">
                        <el-tooltip
                          v-if="isComplete(scope.row)"
                          class="item"
                          effect="dark"
                          content="Completed"
                          placement="top-start"
                        >
                          <el-button
                            type="success"
                            icon="fas fa-check-circle"
                            class="mr-1 mb-1"
                            circle
                          >
                          </el-button>
                        </el-tooltip>
                        <el-tooltip
                          v-else
                          class="item"
                          effect="dark"
                          content="Complete Order"
                          placement="top-start"
                        >
                          <el-button
                            @click="completeOrder(scope.row)"
                            type="bs-info"
                            icon="fas fa-qrcode"
                            class="mr-1 mb-1"
                            circle
                          >
                          </el-button>
                        </el-tooltip>
                        <el-tooltip
                          v-if="scope.row.localPrinted == 0"
                          class="item"
                          effect="dark"
                          content="Print Shipping Label From STAMPS"
                          placement="top-start"
                        >
                          <el-button
                            @click="openPurchaseLabelDialog(scope)"
                            type="bs-success-dark"
                            icon="fas fa-print"
                            class="mr-1 mb-1"
                            circle
                          >
                          </el-button>
                        </el-tooltip>
                        <!--el-tooltip
                          v-if="hasVoidLabel(scope.row)"
                          class="item"
                          effect="dark"
                          content="Cancel Order"
                          placement="top-start"
                        >
                          <el-button
                            type="danger"
                            icon="fas fa-times-circle"
                            class="mr-1 mb-1"
                            circle
                          >
                          </el-button>
                        </el-tooltip-->
                        <el-tooltip
                          v-if="!hasVoidLabel(scope.row)"
                          class="item"
                          effect="dark"
                          content="Print Label Only"
                          placement="top-start"
                        >
                          <el-button
                            @click="displayLabelOnlyDialog(scope.row)"
                            type="bs-success-deep"
                            icon="fas fa-sticky-note"
                            class="mr-1 mb-1"
                            circle
                          >
                          </el-button>
                        </el-tooltip>
                        <el-tooltip
                          v-if="!hasVoidLabel(scope.row)"
                          class="item"
                          effect="dark"
                          content="Print Invoice Only"
                          placement="top-start"
                        >
                          <el-button
                            @click="displayInvoiceOnlyDialog(scope.row)"
                            type="bs-primary-dark"
                            icon="fas fa-file-invoice"
                            class="mr-1 mb-1"
                            circle
                          >
                          </el-button>
                        </el-tooltip>
                        <el-tooltip
                          v-if="!hasVoidLabel(scope.row)"
                          class="item"
                          effect="dark"
                          content="RePrint Packing Slip"
                          placement="top-start"
                        >
                          <el-button
                            type="bs-success-dark"
                            icon="fas fa-print"
                            class="mr-1 mb-1"
                            @click="reprintPackingSlip(scope)"
                            circle
                          >
                          </el-button>
                        </el-tooltip>
                        <el-tooltip
                          v-if="!hasVoidLabel(scope.row)"
                          class="item"
                          effect="dark"
                          content="Shipments List"
                          placement="top-start"
                        >
                          <el-button
                            type="primary"
                            icon="far fa-paper-plane"
                            class="mr-1 mb-1"
                            @click="viewShipmentList(scope.row.id)"
                            circle
                          >
                          </el-button>
                        </el-tooltip>
                        <el-tooltip
                          v-if="
                            !hasVoidLabel(scope.row) &&
                            scope.row.shipmentTrackingNumber !== ''
                          "
                          class="item"
                          effect="dark"
                          content="Track Order Shipment"
                          placement="top-start"
                        >
                          <el-button
                            type="info"
                            icon="fas fa-route"
                            class="mr-1 mb-1"
                            @click="viewTracking(scope.row.id)"
                            circle
                          >
                          </el-button>
                        </el-tooltip>
                        <el-tooltip
                          v-if="
                            scope.row.extendedOrderID.length == 1 &&
                            hasShippingAddress(scope.row)
                          "
                          class="item"
                          effect="dark"
                          content="View Shipping Address on Map"
                          placement="top-start"
                        >
                          <el-link
                            class="expand-item"
                            :underline="false"
                            target="_blank"
                            :href="
                              'https://maps.google.com/?q=' +
                              getShippingAddress(scope.row)
                            "
                          >
                            <el-button
                              type="purple"
                              icon="el-icon-map-location"
                              class="mr-1 mb-1"
                              circle
                            >
                            </el-button>
                          </el-link>
                        </el-tooltip>
                        <!--el-tooltip
                          v-if="!hasVoidLabel(scope.row) && scope.row.deliveredDate == 0"
                          class="item"
                          effect="dark"
                          content="Cancel Shipment"
                          placement="top-start"
                        >
                          <el-button
                            type="warning"
                            icon="fas fa-route"
                            class="mr-1 mb-1"
                            @click="cancelShipment(scope.row.id)"
                            circle
                          >
                          </el-button>
                        </el-tooltip-->
                      </div>
                      <div v-if="formFilter.tab === 'cancelled'">
                        <el-tooltip
                          v-if="hasShippingAddress(scope.row)"
                          class="item"
                          effect="dark"
                          content="View Shipping Address on Map"
                          placement="top-start"
                        >
                          <el-link
                            class="expand-item"
                            :underline="false"
                            target="_blank"
                            :href="
                              'https://maps.google.com/?q=' +
                              getShippingAddress(scope.row)
                            "
                          >
                            <el-button
                              type="purple"
                              icon="fas fa-map-marker-alt"
                              class="mr-1 mb-1"
                              circle
                            >
                            </el-button>
                          </el-link>
                        </el-tooltip>
                        <el-tooltip
                          v-if="scope.row.archived == 0"
                          class="item"
                          effect="dark"
                          content="Archive Order / Product(s) to Review"
                          placement="top-start"
                        >
                          <el-button
                            type="danger"
                            icon="fas fa-undo"
                            class="mr-1 mb-1"
                            circle
                          >
                          </el-button>
                        </el-tooltip>
                      </div>
                      <div v-if="formFilter.tab === 'flagged'">
                        <el-tooltip
                          class="item"
                          effect="dark"
                          content="Force tracking number update"
                          placement="top-start"
                        >
                          <el-button
                            type="warning"
                            icon="fas fa-paper-plane"
                            class="mr-1 mb-1"
                            @click="setShippingTrackingNumber(scope.row)"
                            circle
                          >
                          </el-button>
                        </el-tooltip>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="dataTables_paginate paging_simple_numbers">
                <ul
                  class="pagination pagination-rounded mb-0"
                  style="justify-content: center"
                >
                  <b-pagination
                    v-model="formFilter.page"
                    :total-rows="tabCount[tab.link]"
                    :per-page="formFilter.pageSize"
                  ></b-pagination>
                </ul>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </Layout>
  </div>
</template>
<style>
.order-page-container #tab-flagged .product-tab-link {
  color: white !important
}
.order-page-container .el-table td.el-table__cell {
  padding-top: 8px !important;
  padding-bottom: 4px !important;
  border-bottom: 2px solid #c8c6c6 !important;
}
.order-items-table .el-table td.el-table__cell {
  border-bottom: none;
}
.mr-single-button {
  margin-right: 15px !important
}
.order-page-container .el-table-effect {
  margin: auto !important;
  margin-top: 10px !important;
}
.el-table.el-table-effect.el-table-effect-show {
  width: 85% !important;
}
.el-table-effect-regular {
  width: 100% !important;
} 
.order-page-container .el-table tr:nth-child( odd ) {
  background: #f2f2f2 !important;
}
.order-page-container .el-table tr:nth-child( even ) {
  background: #fafafa !important;
}
.order-page-container .el-table .order-items-table {
  background: none !important;
}
</style>
